module.exports = "/images/vendor/desiigner-svg/svg/ui/chevron-right.svg?6f18b720ccea9187e84217bc984f1603";